var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14901",
    "data-name": "Group 14901",
    transform: "translate(-160 -612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36053",
    "data-name": "Path 36053",
    d: "M184,1238a7,7,0,0,0-7,7v2a1,1,0,0,1-2,0v-2a9,9,0,0,1,18,0v2a1,1,0,0,1-2,0v-2A7,7,0,0,0,184,1238Z",
    transform: "translate(0 -601)",
    fill: "#141416",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36054",
    "data-name": "Path 36054",
    d: "M184,1236a4,4,0,1,0-4-4A4,4,0,0,0,184,1236Zm0,2a6,6,0,1,0-6-6A6,6,0,0,0,184,1238Z",
    transform: "translate(0 -601)",
    fill: "#141416",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path_36392",
    "data-name": "Path 36392",
    width: 46,
    height: 46,
    rx: 23,
    transform: "translate(161 613)",
    fill: "none",
    stroke: "#fd4966",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePeopleIcon);
export default __webpack_public_path__ + "static/media/circlePeopleIcon.387c7e303bf2e1c98730693477d72acc.svg";
export { ForwardRef as ReactComponent };